import { Component, computed, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {
  FooterComponent,
  HeaderComponent,
  OverlayComponent,
} from '@components';
import { CONFIG } from '@config';
import { OverlayService, OverlayState } from '@data-access';
import { provideTranslationDictionaryMapping, TranslateService } from '@i18n';
import posthog from 'posthog-js';
import { OverlayTranslationDictionary } from './i18n/overlay-translation-dictionary.interface';
import { translation } from './i18n/translation.constant';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, OverlayComponent],
  templateUrl: './app.component.html',
  providers: [provideTranslationDictionaryMapping(translation)],
})
export class AppComponent implements OnInit {
  readonly config = inject(CONFIG);
  readonly overlayService = inject(OverlayService);
  readonly OverlayState = OverlayState;
  private readonly translateService = inject(
    TranslateService<OverlayTranslationDictionary>,
  );
  readonly overlayMessage = computed(() => {
    const key = this.overlayService.messageKey();
    return key ? this.translateService.translate(key) : '';
  });

  ngOnInit(): void {
    posthog.setPersonProperties({
      BRAND: this.config.domainId,
    });
  }
}
